export default __webpack_public_path__ + "static/media/dg-dropdown.05398d2c.webp";